import { FaPlus } from "react-icons/fa";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const ProjectDetailsSection = ({ project }) => {
  if (!project) return null;

  return (
    <section className="project-details-section fix section-padding">
      <div className="container">
        <div className="project-details-wrapper">
          {/* Header */}
          <div className="row g-4">
            <div className="col-lg-4">
              <div className="project-details-content">
                <h2>{project.title}</h2>
              </div>
            </div>
            <div className="col-lg-4 ps-lg-5">
              <p>{project.shortDescription}</p>
            </div>
            <div className="col-lg-4 ps-lg-5">
              <div className="project-category-items">
                <ul>
                  <li>
                    Category: <span>{project.categories}</span>
                  </li>
                  <li>
                    Client: <span>{project.client}</span>
                  </li>
                  <li>
                    Start Date: <span>{project.startDate}</span>
                  </li>
                  <li>
                    Handover: <span>{project.handoverDate}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Main Image */}
          <div className="details-image">
            <img
              src={project.mainImage}
              alt="img"
            />
          </div>

          {/* Overview */}
          <div className="project-content-2">
            <h2 className="mb-3">{project.overviewTitle}</h2>
            {project.overviewText.map((text, i) => (
              <p
                key={i}
                className={i === 0 ? "mb-2" : ""}
              >
                {text}
              </p>
            ))}
          </div>

          {/* Additional Images */}
          <div className="row">
            {project.additionalImages.map((img, idx) => (
              <div
                key={idx}
                className={`col-lg-${img.col}`}
              >
                <div className="details-image">
                  <img
                    src={img.src}
                    alt={`details-${idx}`}
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Challenges & Constraints */}
          <div className="project-details-content-3">
            <h2 className="mb-3">{project.challengesTitle}</h2>
            <p>{project.challengesText}</p>
            <div className="details-list-items">
              {project.challengesList.map((list, idx) => (
                <ul key={idx}>
                  {list.map((item, i) => (
                    <li key={i}>
                      <FaPlus /> {item}
                    </li>
                  ))}
                </ul>
              ))}
            </div>

            {/* Solution */}
            <h2 className="mb-3">{project.solutionTitle}</h2>
            <p>{project.solutionText}</p>

            {/* Final Result */}
            <h2 className="mb-3 mt-5">{project.finalResultTitle}</h2>
            <p>{project.finalResultText}</p>
          </div>

          {/* Next / Previous Navigation */}
          <div className="preview-area">
            {project.prevPost && (
              <a
                href={`/du-an/${project.prevPost.slug}`}
                className="preview-item"
              >
                <FaArrowLeft /> {project.prevPost.title}
              </a>
            )}

            {project.nextPost && (
              <a
                href={`/du-an/${project.nextPost.slug}`}
                className="preview-item style-2"
              >
                {project.nextPost.title} <FaArrowRight />
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectDetailsSection;
